var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFirefox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 93,
    viewBox: "0 0 91 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M87.0278 31.1991C85.0693 26.4867 81.0966 21.3987 77.9856 19.7903C80.2046 24.0877 81.7444 28.7028 82.5503 33.4716L82.5585 33.5472C77.4623 20.8416 68.8202 15.7187 61.7621 4.56343C61.4051 3.99938 61.048 3.43418 60.7003 2.83757C60.5014 2.49682 60.3421 2.18979 60.2037 1.90719C59.911 1.3403 59.6854 0.741189 59.5315 0.122013C59.5317 0.0934415 59.5214 0.0657935 59.5025 0.0443437C59.4836 0.0228939 59.4575 0.00914343 59.4291 0.00571546C59.4014 -0.00190515 59.372 -0.00190515 59.3443 0.00571546C59.3384 0.00571546 59.3291 0.0161823 59.3222 0.0185082C59.3152 0.0208342 59.3001 0.031301 59.2896 0.0359529L59.307 0.00571546C47.9854 6.6347 44.1441 18.9064 43.7906 25.0447C39.2693 25.3554 34.9465 27.0215 31.3862 29.8257C31.0148 29.511 30.6266 29.2167 30.2233 28.9441C29.1962 25.3493 29.1525 21.5447 30.0965 17.9272C25.9388 19.9414 22.2444 22.7967 19.2471 26.3123H19.2261C17.4398 24.048 17.5654 16.5817 17.6677 15.0221C17.1393 15.2345 16.6348 15.5023 16.1629 15.8211C14.5859 16.9466 13.1117 18.2094 11.7575 19.5949C10.2143 21.1595 8.80492 22.8506 7.54402 24.6504V24.6574V24.6492C4.64615 28.7575 2.59077 33.3991 1.49653 38.3061L1.43605 38.6038C1.35115 39.0004 1.04529 40.9868 0.992957 41.4182C0.992957 41.452 0.985979 41.4834 0.98249 41.5171C0.587935 43.5678 0.343449 45.6446 0.250977 47.7309L0.250977 47.9635C0.260859 59.2494 4.50402 70.1209 12.1419 78.4296C19.7797 86.7383 30.2565 91.8796 41.5017 92.8373C52.7469 93.795 63.9422 90.4995 72.8751 83.6021C81.808 76.7048 87.8286 66.7073 89.7468 55.5856C89.8224 55.0042 89.8841 54.4285 89.9515 53.8412C90.8799 46.1681 89.8748 38.3847 87.0278 31.1991ZM35.0775 66.4816C35.288 66.5828 35.4857 66.6921 35.7021 66.7886L35.7335 66.8084C35.5148 66.7037 35.2962 66.5948 35.0775 66.4816ZM82.562 33.5577V33.5146L82.5701 33.5623L82.562 33.5577Z",
    fill: "url(#paint0_linear_101_132)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0278 31.1992C85.0693 26.4868 81.0966 21.3987 77.9856 19.7903C80.2046 24.0877 81.7444 28.7028 82.5503 33.4716V33.5147L82.5585 33.5623C86.0326 43.504 85.5301 54.4037 81.1559 63.9835C75.99 75.0679 63.4856 86.429 43.9127 85.8766C22.7639 85.2777 4.13881 69.5844 0.656856 49.03C0.0230327 45.7887 0.656856 44.1454 0.975512 41.5113C0.540823 43.5574 0.298257 45.6397 0.250977 47.7309L0.250977 47.9635C0.260859 59.2494 4.50402 70.121 12.1419 78.4297C19.7797 86.7384 30.2565 91.8796 41.5017 92.8373C52.7469 93.7951 63.9422 90.4996 72.8751 83.6022C81.808 76.7048 87.8286 66.7073 89.7468 55.5857C89.8224 55.0042 89.8841 54.4285 89.9515 53.8412C90.8799 46.1681 89.8748 38.3847 87.0278 31.1992Z",
    fill: "url(#paint1_radial_101_132)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0278 31.1992C85.0693 26.4868 81.0966 21.3987 77.9856 19.7903C80.2046 24.0877 81.7444 28.7028 82.5503 33.4716V33.5147L82.5585 33.5623C86.0326 43.504 85.5301 54.4037 81.1559 63.9835C75.99 75.0679 63.4856 86.429 43.9127 85.8766C22.7639 85.2777 4.13881 69.5844 0.656856 49.03C0.0230327 45.7887 0.656856 44.1454 0.975512 41.5113C0.540823 43.5574 0.298257 45.6397 0.250977 47.7309L0.250977 47.9635C0.260859 59.2494 4.50402 70.121 12.1419 78.4297C19.7797 86.7384 30.2565 91.8796 41.5017 92.8373C52.7469 93.7951 63.9422 90.4996 72.8751 83.6022C81.808 76.7048 87.8286 66.7073 89.7468 55.5857C89.8224 55.0042 89.8841 54.4285 89.9515 53.8412C90.8799 46.1681 89.8748 38.3847 87.0278 31.1992Z",
    fill: "url(#paint2_radial_101_132)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M65.1242 36.4977C65.2219 36.5663 65.3126 36.6349 65.4045 36.7035C64.2723 34.6959 62.8628 32.8577 61.2178 31.2433C47.2085 17.2318 57.5462 0.862853 59.2895 0.0313228L59.307 0.0057373C47.9854 6.63472 44.1441 18.9065 43.7905 25.0447C44.3162 25.0086 44.8372 24.9644 45.3745 24.9644C49.3916 24.9718 53.3352 26.0428 56.8042 28.0686C60.2731 30.0944 63.1438 33.0026 65.1242 36.4977Z",
    fill: "url(#paint3_radial_101_132)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4039 39.2958C45.3294 40.4169 41.3683 44.2838 39.9832 44.2838C27.166 44.2838 25.0854 52.0374 25.0854 52.0374C25.653 58.5664 30.2026 63.944 35.7023 66.7886C35.9535 66.9189 36.2082 67.0363 36.4629 67.1515C36.904 67.3469 37.3452 67.5275 37.7863 67.6934C39.6738 68.3614 41.6507 68.7429 43.6512 68.825C66.1165 69.8787 70.4684 41.9602 54.2564 33.8589C58.081 33.3612 61.954 34.3016 65.1245 36.4977C63.1441 33.0026 60.2734 30.0944 56.8044 28.0686C53.3355 26.0428 49.3919 24.9718 45.3748 24.9644C44.8398 24.9644 44.3165 25.0086 43.7908 25.0447C39.2695 25.3555 34.9468 27.0216 31.3865 29.8257C32.0738 30.4072 32.8495 31.184 34.4835 32.7948C37.5421 35.808 45.3864 38.9295 45.4039 39.2958Z",
    fill: "url(#paint4_radial_101_132)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4039 39.2958C45.3294 40.4169 41.3683 44.2838 39.9832 44.2838C27.166 44.2838 25.0854 52.0374 25.0854 52.0374C25.653 58.5664 30.2026 63.944 35.7023 66.7886C35.9535 66.9189 36.2082 67.0363 36.4629 67.1515C36.904 67.3469 37.3452 67.5275 37.7863 67.6934C39.6738 68.3614 41.6507 68.7429 43.6512 68.825C66.1165 69.8787 70.4684 41.9602 54.2564 33.8589C58.081 33.3612 61.954 34.3016 65.1245 36.4977C63.1441 33.0026 60.2734 30.0944 56.8044 28.0686C53.3355 26.0428 49.3919 24.9718 45.3748 24.9644C44.8398 24.9644 44.3165 25.0086 43.7908 25.0447C39.2695 25.3555 34.9468 27.0216 31.3865 29.8257C32.0738 30.4072 32.8495 31.184 34.4835 32.7948C37.5421 35.808 45.3864 38.9295 45.4039 39.2958Z",
    fill: "url(#paint5_radial_101_132)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2848 28.3266C29.65 28.5592 29.9512 28.7616 30.2152 28.9441C29.1882 25.3493 29.1444 21.5448 30.0884 17.9272C25.9307 19.9414 22.2363 22.7967 19.239 26.3123C19.4588 26.3065 25.9971 26.189 29.2848 28.3266Z",
    fill: "url(#paint6_radial_101_132)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0.662752 49.03C4.14122 69.5844 22.7698 85.2777 43.9186 85.8766C63.4915 86.4302 75.9959 75.0679 81.1618 63.9835C85.536 54.4037 86.0385 43.504 82.5644 33.5623V33.5193C82.5644 33.4856 82.5574 33.4658 82.5644 33.4763L82.5725 33.5519C84.1716 43.9919 78.8615 54.1063 70.5601 60.9458L70.5345 61.004C54.3598 74.177 38.8806 68.9518 35.7475 66.8189C35.5289 66.7142 35.3102 66.6053 35.0916 66.4921C25.661 61.9844 21.765 53.3923 22.6 46.0237C20.3614 46.0567 18.1613 45.4398 16.2661 44.2477C14.371 43.0557 12.8623 41.3396 11.9227 39.3074C14.3982 37.7909 17.2209 36.9335 20.1217 36.817C23.0226 36.7006 25.9049 37.3289 28.494 38.6422C33.8319 41.0655 39.906 41.3042 45.4177 39.3074C45.4002 38.9411 37.5559 35.8185 34.4973 32.8064C32.8633 31.1957 32.0876 30.42 31.4003 29.8373C31.0288 29.5227 30.6406 29.2284 30.2373 28.9558C29.9698 28.7732 29.6686 28.5755 29.3069 28.3382C26.0192 26.2007 19.4809 26.3181 19.2646 26.324H19.2437C17.4573 24.0596 17.5829 16.5933 17.6853 15.0338C17.1568 15.2461 16.6524 15.514 16.1804 15.8327C14.6034 16.9582 13.1292 18.2211 11.775 19.6066C10.2263 21.1668 8.81108 22.8539 7.5441 24.6504V24.6574V24.6493C4.64624 28.7576 2.59085 33.3992 1.49661 38.3061C1.47451 38.398 -0.126911 45.3991 0.662752 49.03Z",
    fill: "url(#paint7_radial_101_132)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2204 31.2433C62.8659 32.8595 64.2753 34.6996 65.4071 36.7093C65.6548 36.8966 65.8862 37.0826 66.0828 37.2629C76.3019 46.683 70.9475 59.9991 70.5486 60.947C78.85 54.1075 84.1555 43.9931 82.561 33.553C77.4625 20.8416 68.8204 15.7187 61.7623 4.56343C61.4053 3.99938 61.0482 3.43418 60.7005 2.83757C60.5016 2.49682 60.3423 2.18979 60.2039 1.90719C59.9112 1.3403 59.6856 0.741188 59.5317 0.122013C59.5319 0.0934415 59.5216 0.0657935 59.5027 0.0443437C59.4838 0.0228939 59.4577 0.00914343 59.4294 0.00571546C59.4016 -0.00190515 59.3723 -0.00190515 59.3445 0.00571546C59.3387 0.00571546 59.3294 0.0161823 59.3224 0.0185082C59.3154 0.0208342 59.3003 0.031301 59.2898 0.0359529C57.5465 0.862831 47.2088 17.2318 61.2204 31.2433Z",
    fill: "url(#paint8_radial_101_132)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M66.0757 37.2571C65.8791 37.0768 65.6477 36.8908 65.4 36.7035C65.3081 36.6349 65.2174 36.5663 65.1197 36.4977C61.9492 34.3016 58.0762 33.3612 54.2517 33.8589C70.4636 41.9648 66.1141 69.8787 43.6465 68.825C41.646 68.7428 39.669 68.3614 37.7816 67.6934C37.3404 67.5283 36.8993 67.3476 36.4581 67.1515C36.2034 67.0352 35.9487 66.9189 35.6975 66.7886L35.7289 66.8084C38.862 68.9471 54.3366 74.1724 70.5159 60.9935L70.5415 60.9353C70.9451 59.9933 76.2994 46.6737 66.0757 37.2571Z",
    fill: "url(#paint9_radial_101_132)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0852 52.0374C25.0852 52.0374 27.1658 44.2839 39.983 44.2839C41.3681 44.2839 45.3327 40.417 45.4036 39.2958C39.892 41.2926 33.8179 41.0539 28.48 38.6306C25.8908 37.3173 23.0085 36.689 20.1077 36.8054C17.2069 36.9219 14.3842 37.7793 11.9087 39.2958C12.8483 41.328 14.357 43.0441 16.2521 44.2361C18.1472 45.4282 20.3474 46.0451 22.586 46.012C21.751 53.3818 25.647 61.9739 35.0776 66.4805C35.2881 66.5817 35.4858 66.691 35.7021 66.7875C30.1977 63.944 25.6528 58.5664 25.0852 52.0374Z",
    fill: "url(#paint10_radial_101_132)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0278 31.1991C85.0693 26.4867 81.0966 21.3987 77.9856 19.7903C80.2046 24.0877 81.7444 28.7028 82.5503 33.4716L82.5585 33.5472C77.4623 20.8416 68.8202 15.7187 61.7621 4.56343C61.4051 3.99938 61.048 3.43418 60.7003 2.83757C60.5014 2.49682 60.3421 2.18979 60.2037 1.90719C59.911 1.3403 59.6854 0.741189 59.5315 0.122013C59.5317 0.0934415 59.5214 0.0657935 59.5025 0.0443437C59.4836 0.0228939 59.4575 0.00914343 59.4291 0.00571546C59.4014 -0.00190515 59.372 -0.00190515 59.3443 0.00571546C59.3384 0.00571546 59.3291 0.0161823 59.3222 0.0185082C59.3152 0.0208342 59.3001 0.031301 59.2896 0.0359529L59.307 0.00571546C47.9854 6.6347 44.1441 18.9064 43.7906 25.0447C44.3162 25.0086 44.8373 24.9644 45.3746 24.9644C49.3917 24.9718 53.3352 26.0428 56.8042 28.0686C60.2732 30.0943 63.1438 33.0026 65.1243 36.4977C61.9538 34.3016 58.0807 33.3612 54.2562 33.8589C70.4681 41.9648 66.1186 69.8787 43.651 68.825C41.6505 68.7428 39.6736 68.3614 37.7861 67.6934C37.345 67.5283 36.9038 67.3476 36.4626 67.1515C36.208 67.0352 35.9533 66.9189 35.7021 66.7886L35.7335 66.8084C35.5148 66.7037 35.2962 66.5948 35.0775 66.4816C35.288 66.5828 35.4857 66.6921 35.7021 66.7886C30.1977 63.944 25.6528 58.5664 25.0852 52.0374C25.0852 52.0374 27.1658 44.2838 39.983 44.2838C41.3681 44.2838 45.3327 40.4169 45.4036 39.2958C45.3862 38.9295 37.5419 35.8069 34.4833 32.7947C32.8493 31.184 32.0736 30.4083 31.3862 29.8257C31.0148 29.511 30.6266 29.2167 30.2233 28.9441C29.1962 25.3493 29.1525 21.5447 30.0965 17.9272C25.9388 19.9414 22.2444 22.7967 19.2471 26.3123H19.2261C17.4398 24.048 17.5654 16.5817 17.6677 15.0221C17.1393 15.2345 16.6348 15.5023 16.1629 15.8211C14.5859 16.9466 13.1117 18.2094 11.7575 19.5949C10.2143 21.1595 8.80492 22.8506 7.54402 24.6504V24.6574V24.6492C4.64615 28.7575 2.59077 33.3991 1.49653 38.3061L1.43605 38.6038C1.35115 39.0004 0.97086 41.0147 0.9162 41.4473C0.9162 41.4136 0.9162 41.4799 0.9162 41.4473C0.568366 43.5266 0.346221 45.6249 0.250977 47.7309L0.250977 47.9635C0.260859 59.2494 4.50402 70.1209 12.1419 78.4296C19.7797 86.7383 30.2565 91.8796 41.5017 92.8373C52.7469 93.795 63.9422 90.4995 72.8751 83.6021C81.808 76.7048 87.8286 66.7073 89.7468 55.5856C89.8224 55.0042 89.8841 54.4285 89.9515 53.8412C90.8799 46.1681 89.8748 38.3847 87.0278 31.1991ZM82.5562 33.5146L82.5643 33.5623L82.5562 33.5146Z",
    fill: "url(#paint11_linear_101_132)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_101_132",
    x1: 81.0617,
    y1: 14.408,
    x2: 6.23681,
    y2: 86.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.048,
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.111,
    stopColor: "#FFE847"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.225,
    stopColor: "#FFC830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.368,
    stopColor: "#FF980E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.401,
    stopColor: "#FF8B16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.462,
    stopColor: "#FF672A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.534,
    stopColor: "#FF3647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.705,
    stopColor: "#E31587"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_101_132",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(77.6042 10.3211) scale(93.9652 93.9652)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.129,
    stopColor: "#FFBD4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.186,
    stopColor: "#FFAC31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.247,
    stopColor: "#FF9D17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.283,
    stopColor: "#FF980E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.403,
    stopColor: "#FF563B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.467,
    stopColor: "#FF3750"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#F5156C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.782,
    stopColor: "#EB0878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#E50080"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_101_132",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(43.2685 48.7369) scale(93.9652 93.9652)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#960E18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351,
    stopColor: "#B11927",
    stopOpacity: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.435,
    stopColor: "#DB293D",
    stopOpacity: 0.343
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.497,
    stopColor: "#F5334B",
    stopOpacity: 0.094
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FF3750",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_101_132",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(54.5967 -11.0031) scale(68.0738 68.0738)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.132,
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.252,
    stopColor: "#FFDC3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.506,
    stopColor: "#FF9D12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526,
    stopColor: "#FF980E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_101_132",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.8752 73.281) scale(44.741 44.741)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.353,
    stopColor: "#3A8EE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.472,
    stopColor: "#5C79F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.669,
    stopColor: "#9059FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C139E6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_101_132",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.4033 41.0361) rotate(-13.5916) scale(23.7214 27.7718)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.206,
    stopColor: "#9059FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.278,
    stopColor: "#8C4FF3",
    stopOpacity: 0.064
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747,
    stopColor: "#7716A8",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#6E008B",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_101_132",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.0822 6.47667) scale(32.1866 32.1866)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE226"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FFDB27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.295,
    stopColor: "#FFC82A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.502,
    stopColor: "#FFA930"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.732,
    stopColor: "#FF7E37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792,
    stopColor: "#FF7139"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_101_132",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(67.3816 -13.939) scale(137.326 137.326)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.113,
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.456,
    stopColor: "#FF980E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.622,
    stopColor: "#FF5634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.716,
    stopColor: "#FF3647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#E31587"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_101_132",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(55.8077 -6.30295) rotate(83.976) scale(100.649 66.0552)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#FFE847"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.168,
    stopColor: "#FFC830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304,
    stopColor: "#FF980E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.356,
    stopColor: "#FF8B16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.455,
    stopColor: "#FF672A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#FF3647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.737,
    stopColor: "#E31587"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_101_132",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(41.3242 18.3983) scale(85.7348 85.7348)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.137,
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FF980E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.592,
    stopColor: "#FF5634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.655,
    stopColor: "#FF3647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#E31587"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_101_132",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(63.9556 23.4161) scale(93.8361 93.8361)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.094,
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.231,
    stopColor: "#FFE141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.509,
    stopColor: "#FFAF1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.626,
    stopColor: "#FF980E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_101_132",
    x1: 80.1627,
    y1: 14.0219,
    x2: 16.4943,
    y2: 77.6892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.167,
    stopColor: "#FFF44F",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.266,
    stopColor: "#FFF44F",
    stopOpacity: 0.634
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489,
    stopColor: "#FFF44F",
    stopOpacity: 0.217
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FFF44F",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirefox);
export default __webpack_public_path__ + "static/media/firefox.d17db02190ef29429a693e5d9fd44215.svg";
export { ForwardRef as ReactComponent };